import { render, staticRenderFns } from "./HistoryIcon.vue?vue&type=template&id=f1505584&scoped=true&"
import script from "./HistoryIcon.vue?vue&type=script&lang=js&"
export * from "./HistoryIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1505584",
  null
  
)

export default component.exports